'use es6';

import ActionTypes from './ActionTypes';
export const openAcademyToSoftwareModal = (source = 'NAV_CTA', selectedSoftware) => ({
  type: ActionTypes.ACADEMY_TO_SOFTWARE_SET_MODAL_OPEN,
  payload: {
    SOURCE: source,
    SELECTEDSOFTWARE: selectedSoftware
  }
});
export const closeAcademyToSoftwareModal = () => ({
  type: ActionTypes.ACADEMY_TO_SOFTWARE_SET_MODAL_CLOSED
});
export const showTooltip = () => ({
  type: ActionTypes.ACADEMY_TO_SOFTWARE_SHOW_TOOLTIP
});
export const hideTooltip = () => ({
  type: ActionTypes.ACADEMY_TO_SOFTWARE_HIDE_TOOLTIP
});